<template>
  <div class="section-showtime">
    <!--Start Desktop Banner Slider--->
    <section class="section-banner simple-banner d-none d-md-block">
      <slick ref="banner-slider" :options="bannerSlider">
        <div class="w-100 banner-slider">
          <div class="banner-img">
            <div>
              <img
                :src="movieBanner"
                class="image"
                onerror="javascript:this.src='/static/img/default-banner.jpg'"
              />
            </div>
          </div>
        </div>
      </slick>
    </section>
    <!--End Desktop Banner Slider--->

    <!--Start Mobile View-->
    <MobileMovieDetails
      v-if="movieDetails[0]"
      :categoryId="CategoryID"
      :confirmedMovie="confirmedMovie"
      :langNames="
        getSafe(
          () =>
            Array.from(
              new Set(
                filteredFlattenedSchedule.map((data) =>
                  movieLanguagesWithSubs(
                    getSafe(
                      () => data.schedules[0].lang_name,
                      getSafe(
                        () => data.schedules_after_midnight[0].lang_name,
                        ''
                      )
                    )
                  )
                )
              )
            )
              .sort()
              .join(', '),
          ''
        )
      "
      :movieData="movieDetails"
    />

    <!--End Mobile View-->

    <div :class="!movieBanner ? 'pt-lg-5 mt-lg-3' : ''" class="container">
      <div class="mt-lg-4 mt-3 d-none d-md-block">
        <div class="content mb-4">
          <div class="content-title my-3">
            {{ movieName }}
          </div>
          <div class="content-desc">
            {{ movieDescrip }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="CategoryID != '2'" class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <div class="mb-4 pb-2">
            <!--Start date Slider-->
            <div class="date-slider empire-slider px-md-4 py-3">
              <slick
                v-if="dateList.length > 0"
                ref="dateSlider"
                :options="dateSlider"
              >
                <template v-if="langName !== 'ar'">
                  <div
                    v-for="(dateInfo, dateKey) in dateList"
                    :key="dateKey"
                    v-on:click="
                      setSelectedDate(dateInfo.ss_actual_start_date, dateInfo)
                    "
                  >
                    <div
                      :class="
                        selectedDate == null && dateKey == 0
                          ? 'date-card-active'
                          : selectedDate == dateInfo.ss_actual_start_date
                          ? 'date-card-active'
                          : ''
                      "
                      class="date-card"
                    >
                      <div class="month">
                        {{
                          moment(dateInfo.ss_actual_start_date)
                            .locale(
                              getCurrentLang().iso_2
                                ? getCurrentLang().iso_2
                                : "en"
                            )
                            .format("MMM")
                        }}
                      </div>
                      <div class="date py-1">
                        {{
                          moment(dateInfo.ss_actual_start_date)
                            .locale(
                              getCurrentLang().iso_2
                                ? getCurrentLang().iso_2
                                : "en"
                            )
                            .format("DD")
                        }}
                      </div>
                      <div class="day">
                        {{
                          moment(dateInfo.ss_actual_start_date)
                            .locale(
                              getCurrentLang().iso_2
                                ? getCurrentLang().iso_2
                                : "en"
                            )
                            .format("ddd")
                        }}
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div
                    v-for="(dateInfo, dateKey) in dateList.slice().reverse()"
                    :key="dateKey"
                    v-on:click="
                      setSelectedDate(dateInfo.ss_actual_start_date, dateInfo)
                    "
                  >
                    <div
                      :class="
                        selectedDate == null && dateKey === dateList.length - 1
                          ? 'date-card-active'
                          : selectedDate == dateInfo.ss_actual_start_date
                          ? 'date-card-active'
                          : ''
                      "
                      class="date-card"
                    >
                      <div class="month">
                        {{
                          moment(dateInfo.ss_actual_start_date)
                            .locale(
                              getCurrentLang().iso_2
                                ? getCurrentLang().iso_2
                                : "en"
                            )
                            .format("MMM")
                        }}
                      </div>
                      <div class="date py-1">
                        {{
                          moment(dateInfo.ss_actual_start_date)
                            .locale(
                              getCurrentLang().iso_2
                                ? getCurrentLang().iso_2
                                : "en"
                            )
                            .format("DD")
                        }}
                      </div>
                      <div class="day">
                        {{
                          moment(dateInfo.ss_actual_start_date)
                            .locale(
                              getCurrentLang().iso_2
                                ? getCurrentLang().iso_2
                                : "en"
                            )
                            .format("ddd")
                        }}
                      </div>
                    </div>
                  </div>
                </template>
              </slick>
              <div v-else-if="!is_loading">NO SHOWS FOUND</div>
            </div>
            <!--End date Slider-->
            <!--Start QuickBook--->
            <div v-if="BrijScheduled.length > 0" class="row emp-quickbook mx-0">
              <div class="col-md-2"></div>
              <div class="col-md-8">
                <div
                  class="row align-items-center mt-n1 mx-0 px-0 py-3 animate__animated animate__fadeInDown"
                >
                  <div class="col-xl-4 col-lg-6 col-md-6 px-1 mb-2 mb-xl-0">
                    <multiselect
                      v-model="selectedCinemaValues"
                      :clear-on-select="false"
                      :close-on-select="false"
                      :custom-label="getCinemaTranslatedName"
                      :deselect-label="''"
                      :disabled="hideCinemaFilter == true ? true : false"
                      :multiple="true"
                      :options="confirmedMovie.CinemaArray"
                      :placeholder="allLanguageData.QuickBook.selectCinema"
                      :preserve-search="true"
                      :select-label="''"
                      :selectedLabel="''"
                      class="custom-multiselect no-scroll"
                      track-by="cinema_id"
                      :class="{ 'multiselect-arabic': langName === 'ar' }"
                      :style="{
                        textAlign: langName === 'ar' ? 'right' : 'left',
                      }"
                    >
                      <template
                        slot="selection"
                        slot-scope="{ values, search, isOpen }"
                        ><span
                          v-if="values.length>1 && values.length &amp;&amp; !isOpen"
                          class="multiselect__single"
                          >{{ values.length }} Cinemas</span
                        >
                        <span
                          v-else-if=" values.length &amp;&amp; !isOpen"
                          class="multiselect__single"
                          >{{ getCinemaTranslatedName(values[0]) }}</span
                        ></template
                      >
                    </multiselect>
                    <!-- <b-dropdown
                  variant="default"
                  class="quickbook-dropdown"
                  text="Select Cinema"
                >
                  <b-dropdown-item v-for="(data, Index) in 10" :key="Index"
                    >Cinema One</b-dropdown-item
                  >
                </b-dropdown> -->
                  </div>

                  <div class="col-xl-4 col-lg-6 col-md-6 px-1 mb-2 mb-xl-0">
                    <multiselect
                      v-model="selectedExpValues"
                      :clear-on-select="false"
                      :close-on-select="false"
                      :deselect-label="''"
                      :multiple="true"
                      :options="
                        langName === 'ar'
                          ? getOptionsWithArabicNames(
                              confirmedMovie.FormatArray
                            )
                          : confirmedMovie.FormatArray
                      "
                      :placeholder="allLanguageData.QuickBook.selectExp"
                      :preserve-search="true"
                      :select-label="''"
                      :selectedLabel="''"
                      class="custom-multiselect scroll-dropdown experience-dropdown"
                      label="mf_name"
                      track-by="mf_id"
                      :class="{ 'multiselect-arabic': langName === 'ar' }"
                      :style="{
                        textAlign: langName === 'ar' ? 'right' : 'left',
                      }"
                    >
                      <template
                        slot="selection"
                        slot-scope="{ values, search, isOpen }"
                        ><span
                          v-if="values.length > 1 &amp;&amp; !isOpen"
                          class="multiselect__single"
                          >{{ values.length }} Experience</span
                        >
                        <span
                          v-else-if="values.length &amp;&amp; !isOpen"
                          class="multiselect__single"
                          >{{ values[0].mf_name }}</span
                        >
                      </template>
                    </multiselect>
                  </div>
                  <div class="col-xl-4 col-lg-6 col-md-6 px-1">
                    <multiselect
                      v-model="selectedShowTimes"
                      :clear-on-select="false"
                      :close-on-select="false"
                      :deselect-label="''"
                      :multiple="true"
                      :options="confirmedMovie.sessions"
                      :placeholder="allLanguageData.QuickBook.selectShowTimes"
                      :preserve-search="true"
                      :select-label="''"
                      :selectedLabel="''"
                      class="custom-multiselect scroll-dropdown"
                      label="label"
                      track-by="label"
                      :class="{ 'multiselect-arabic': langName === 'ar' }"
                      :style="{
                        textAlign: langName === 'ar' ? 'right' : 'left',
                      }"
                    >
                      <template slot="option" slot-scope="{ option }">
                        <span>{{
                          langName === "ar"
                            ? option.alternateLangName
                            : option.label
                        }}</span>
                      </template>
                      <template
                        slot="selection"
                        slot-scope="{ values, search, isOpen }"
                        ><span
                          v-if="values.length > 1 &amp;&amp; !isOpen"
                          class="multiselect__single"
                          >{{ values.length }} Time</span
                        >
                        <span
                          v-else-if="values.length &amp;&amp; !isOpen"
                          class="multiselect__single"
                        >
                          <!-- {{ values[0].label }} -->
                          {{
                            langName === "ar"
                              ? values
                                  .map((option) => option.alternateLangName)
                                  .join(", ")
                              : values.map((option) => option.label).join(", ")
                          }}
                        </span>
                      </template>
                    </multiselect>
                  </div>
                </div>
              </div>
              <!--  <div class="col-md-2 mb-3 mb-md-0 show-view">
           <div
              class="border-right pr-2"
              v-on:click="showView('list')"
              :class="listView ? 'view-active' : ''"
            >
              <svg viewBox="0 0 18.23 21.56">
                <line class="cls-1" x1="18.23" y1="1.54" x2="5.04" y2="1.54" />
                <line class="cls-1" x1="18.23" y1="7.98" x2="5.04" y2="7.98" />
                <line
                  class="cls-1"
                  x1="18.23"
                  y1="13.47"
                  x2="5.04"
                  y2="13.47"
                />
                <line
                  class="cls-1"
                  x1="18.23"
                  y1="19.92"
                  x2="5.04"
                  y2="19.92"
                />
                <ellipse
                  class="cls-1"
                  cx="1.74"
                  cy="1.78"
                  rx="1.24"
                  ry="1.28"
                />
                <ellipse
                  class="cls-1"
                  cx="1.74"
                  cy="7.78"
                  rx="1.24"
                  ry="1.28"
                />
                <ellipse
                  class="cls-1"
                  cx="1.74"
                  cy="13.78"
                  rx="1.24"
                  ry="1.28"
                />
                <ellipse
                  class="cls-1"
                  cx="1.74"
                  cy="19.77"
                  rx="1.24"
                  ry="1.28"
                />
              </svg>
            </div>
            <div
              class="pl-2"
              v-on:click="showView('grid')"
              :class="gridView ? 'view-active' : ''"
            >
              <svg viewBox="0 0 18.3 19.62">
                <rect
                  class="cls-1"
                  x="0.25"
                  y="0.25"
                  width="7.25"
                  height="7.25"
                />
                <rect
                  class="cls-1"
                  x="0.25"
                  y="12.12"
                  width="7.25"
                  height="7.25"
                />
                <rect
                  class="cls-1"
                  x="10.8"
                  y="0.25"
                  width="7.25"
                  height="7.25"
                />
                <rect
                  class="cls-1"
                  x="10.8"
                  y="12.12"
                  width="7.25"
                  height="7.25"
                />
              </svg>
            </div>
          </div> -->
            </div>
            <!---End QuickBook--->
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <!--Desktop View--->
          <div
            v-if="listView && movieDetails[0]"
            class="row emp-showtimes mx-0 mb-5 d-none d-md-block"
          >
            <div
              v-for="(data, index) in filteredFlattenedSchedule"
              v-if="filteredFlattenedSchedule"
              :key="index"
              class="col-md-12 showtime-list mx-0"
            >
              <div class="row mx-0 d-flex align-items-center pt-4 pb-3">
                <div class="col-md-2 px-0">
                  {{
                    getCinemaTranslatedName(
                      getSafe(
                        () => data.schedules[0].cinema,
                        getSafe(
                          () => data.schedules_after_midnight[0].cinema,
                          ""
                        )
                      )
                    )
                  }}
                </div>
                <div class="col-md-3 grid-half align-items-center">
                  <div class="movie-img">
                    <img
                      :src="
                        checkBaseUrl(
                          getLangSpecificAttribute(
                            movieDetails[0].altMovieContent,
                            getCurrentLang().brij_lang_id,
                            'artwork'
                          ) || movieDetails[0].artwork
                        )
                      "
                      class="image img-fluid"
                      onerror="javascript:this.src='/static/img/default-Img.png'"
                    />
                  </div>
                  <div v-bind:class="langName == 'ar' ? 'pr-3' : 'pl-3'">
                    {{ movieName }}
                  </div>
                </div>
                <div class="col-md-2 ar-number">
                  <!-- <div>
                    {{ data.mf_names }} -
                    {{
                      movieLanguagesWithSubs(
                        getSafe(
                          () => data.schedules[0].lang_name,
                          getSafe(
                            () => data.schedules_after_midnight[0].lang_name,
                            ""
                          )
                        ),
                        getSafe(
                          () => data.schedules[0].sub_lang_1_iso_2,
                          getSafe(
                            () =>
                              data.schedules_after_midnight[0].sub_lang_1_iso_2,
                            ""
                          )
                        ),
                        getSafe(
                          () => data.schedules[0].sub_lang_2_iso_2,
                          getSafe(
                            () =>
                              data.schedules_after_midnight[0].sub_lang_2_iso_2,
                            ""
                          )
                        )
                      )
                    }}
                  </div> -->
                  <div>
                    <!-- {{ data.mf_names }} - -->
                    {{
                      langName === "ar"
                        ? getSafe(
                            () =>
                              data.mf_names
                                .replace("MINIS", "مينيز")
                                .replace("SPHERA", "سفيرا")
                                .replace("IMAX", "أيماكس")
                                .replace("SCREEN X", "سكرين أكس")
                                .replace("4DX", "فور دي اكس")
                                .replace("4D X", "فور دي اكس")
                                .replace("2D ATMOS", "أتموس ثنائي الأبعاد")
                                .replace("EMPIRE PREMIERE", "امباير بريمير")
                                .replace("3D ATMOS", "أجواء ثلاثية الأبعاد"),
                            data.mf_names
                          )
                        : data.mf_names
                    }}-
                    {{
                      langName === "ar"
                        ? movieLanguagesWithSubs(
                            getSafe(
                              () => data.schedules[0].lang_name,
                              getSafe(
                                () =>
                                  data.schedules_after_midnight[0].lang_name,
                                ""
                              )
                            )
                              .replace("Hindi", "الهندية")
                              .replace("Tagalog", "التاغالوغية")
                              .replace("Malayalam", "المالايالامية")
                              .replace("Tamil", "التاميل")
                              .replace("Arabic", "عربي")
                              .replace("Japanese", "اليابانية")
                              .replace("English", "إنجليزي") +
                              "/" +
                              getSafe(
                                () => data.schedules[0].sub_lang_1_iso_2,
                                getSafe(
                                  () =>
                                    data.schedules_after_midnight[0]
                                      .sub_lang_1_iso_2,
                                  ""
                                )
                              )
                                .replace("EA", "عربي")
                                .replace("EN", "إن")
                                .replace("JA", "جأ")
                                .replace("AR", "أر"),
                            // getSafe(
                            //   () => data.schedules[0].sub_lang_1_iso_2,
                            //   getSafe(
                            //     () =>
                            //       data.schedules_after_midnight[0].sub_lang_1_iso_2,
                            //     ""
                            //   )
                            // ),
                            getSafe(
                              () => data.schedules[0].sub_lang_2_iso_2,
                              getSafe(
                                () =>
                                  data.schedules_after_midnight[0]
                                    .sub_lang_2_iso_2,
                                ""
                              )
                            )
                          )
                        : movieLanguagesWithSubs(
                            getSafe(
                              () => data.schedules[0].lang_name,
                              getSafe(
                                () =>
                                  data.schedules_after_midnight[0].lang_name,
                                ""
                              )
                            ),
                            getSafe(
                              () => data.schedules[0].sub_lang_1_iso_2,
                              getSafe(
                                () =>
                                  data.schedules_after_midnight[0]
                                    .sub_lang_1_iso_2,
                                ""
                              )
                            ),
                            getSafe(
                              () => data.schedules[0].sub_lang_2_iso_2,
                              getSafe(
                                () =>
                                  data.schedules_after_midnight[0]
                                    .sub_lang_2_iso_2,
                                ""
                              )
                            )
                          )
                    }}
                  </div>
                </div>
                <div class="col-md-5 px-0">
                  <ul class="list-inline showtimes__time-tag">
                    <!-- <li
                      v-for="(schedule, indexschedule) in data.schedules"
                      :key="indexschedule"
                      v-b-tooltip.hover
                      :class="[schedule.showTime]"
                      :title="`${
                        langName === 'ar'
                          ? getArabicScreenName(schedule.screen_name) +
                            (schedule.mf_arabic_name
                              ? ` - ${schedule.mf_arabic_name}`
                              : '')
                          : schedule.screen_name
                      }${
                        schedule.show_timing_label
                          ? ` - ${
                              langName === 'ar'
                                ? getArabicTimeLabel(schedule.show_timing_label)
                                : schedule.show_timing_label
                            }`
                          : ''
                      }`"
                      class="list-inline-item time-tag"
                      @click="seatLayoutShowBrij(schedule, data)"
                    >
                      <a class="text-white">
                        {{
                          moment(schedule.showTime, ["HH.mm"])
                            .locale(getCurrentLang().iso_2 || "en")
                            .format("hh:mm A")
                        }}
                      </a>
                    </li> -->
                    <li
                      class="time-tag list-inline-item"
                      :class="[schedule.showTime]"
                      v-for="(schedule, indexTime) in data.schedules"
                      :key="indexTime"
                      @click="seatLayoutShowBrij(schedule, data)"
                      v-b-tooltip.hover
                      :title="`${
                        langName === 'ar'
                          ? getArabicScreenName(schedule.screen_name) +
                            (schedule.mf_arabic_name
                              ? ` - ${schedule.mf_arabic_name}`
                              : '')
                          : schedule.screen_name
                      }${
                        schedule.mf_name
                          ? ` - ${
                              langName === 'ar'
                                ? getArabicmfName(schedule.mf_name)
                                : schedule.mf_name
                            }`
                          : ''
                      }${
                        schedule.show_timing_label
                          ? ` - ${
                              langName === 'ar'
                                ? getArabicTimeLabel(schedule.show_timing_label)
                                : schedule.show_timing_label
                            }`
                          : ''
                      }${
                        schedule.isPrevDayAmShow
                          ? ' - صباح الباكر'
                          : schedule.isNextDayAmShow
                          ? ' - منتصف الليل'
                          : ''
                      }`"
                    >
                      <router-link to>{{
                        moment(schedule.showTime, ["HH.mm"])
                          .locale(getCurrentLang().iso_2 || "en")
                          .format("hh:mm A")
                      }}</router-link>
                    </li>
                  </ul>

                  <!--
                  <ul class="w-60 mb-2 row showtime-line" v-if="data.schedules_after_midnight.length > 0">
                    <img
                      src="@/assets/img/new-img/svg-img/vertical-line.svg"
                      class="image img-fluid"
                    />
                  </ul>
                  -->
                  <div
                    class="d-flex justify-center justify-content-center align-items-center align-content-center"
                    style="min-width: 275px"
                    v-if="data.schedules_after_midnight.length > 0"
                  >
                    <div style="width: 36%"><hr /></div>
                    <span
                      class="d-flex justify-center justify-content-center align-items-center align-content-center px-2 font-weight-light"
                      style="flex-direction: row"
                    >
                      {{ allLanguageData.AfterMidnight }}
                    </span>
                    <div style="width: 36%"><hr /></div>
                  </div>

                  <ul
                    class="list-inline showtimes__time-tag schedules_after_midnight"
                    v-if="data.schedules_after_midnight.length > 0"
                  >
                    <!-- <li
                      v-for="(
                        schedule, indexschedule
                      ) in data.schedules_after_midnight"
                      :key="indexschedule"
                      v-b-tooltip.hover
                      :class="[schedule.showTime]"
                      :title="`${schedule.screen_name}${
                        schedule.mf_name ? ` - ${schedule.mf_name}` : ''
                      }${
                        schedule.show_timing_label
                          ? ` - ${
                              schedule.isPrevDayAmShow
                                ? 'Early Morning'
                                : schedule.isNextDayAmShow
                                ? `${allLanguageData.AfterMidnight}`
                                : schedule.show_timing_label
                            }`
                          : ''
                      }`"
                      class="list-inline-item time-tag"
                      @click="seatLayoutShowBrij(schedule, data)"
                    >
                      <a class="text-white">
                        {{
                          moment(schedule.showTime, ["HH.mm"])
                            .locale(getCurrentLang().iso_2 || "en")
                            .format("hh:mm A")
                        }}
                      </a>
                    </li> -->
                    <li
                      v-for="(
                        schedule, indexschedule
                      ) in data.schedules_after_midnight"
                      :key="indexschedule"
                      v-b-tooltip.hover
                      :class="[schedule.showTime]"
                      :title="`${
                        langName === 'ar'
                          ? getArabicScreenName(schedule.screen_name) +
                            (schedule.mf_arabic_name
                              ? ` - ${schedule.mf_arabic_name}`
                              : '')
                          : schedule.screen_name
                      }${
                        schedule.mf_name
                          ? ` - ${
                              langName === 'ar'
                                ? getArabicmfName(schedule.mf_name)
                                : schedule.mf_name
                            }`
                          : ''
                      }${
                        schedule.show_timing_label
                          ? ` - ${
                              langName === 'ar'
                                ? getArabicTimeLabel(schedule.show_timing_label)
                                : schedule.show_timing_label
                            }`
                          : ''
                      }${
                        schedule.isPrevDayAmShow
                          ? ' - صباح الباكر'
                          : schedule.isNextDayAmShow
                          ? ' - منتصف الليل'
                          : ''
                      }`"
                      class="list-inline-item time-tag"
                      @click="seatLayoutShowBrij(schedule, data)"
                    >
                      <a class="text-white">
                        {{
                          moment(schedule.showTime, ["HH.mm"])
                            .locale(getCurrentLang().iso_2 || "en")
                            .format("hh:mm A")
                        }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="row showtime-line">
                <img
                  class="image img-fluid"
                  src="@/assets/img/new-img/svg-img/vertical-line.svg"
                />
              </div>
            </div>

            <div>
              <div class="no-shows-found"></div>
            </div>
          </div>
        </div>
      </div>

      <!--End Desktop View-->
      <!--Start Mobile View--->
      <div
        v-if="listView && movieDetails[0]"
        class="row emp-showtimes mx-0 mb-5 d-block d-md-none"
      >
        <div
          v-for="(data, index) in filteredFlattenedSchedule"
          v-if="filteredFlattenedSchedule"
          :key="index"
          class="col-md-12 showtime-list mx-0 px-0"
        >
          <div class="row mx-0 py-3">
            <div class="col-12 title">
              {{ data.mf_names }} -
              {{
                movieLanguagesWithSubs(
                  getSafe(
                    () => data.schedules[0].lang_name,
                    getSafe(
                      () => data.schedules_after_midnight[0].lang_name,
                      ""
                    )
                  ),
                  getSafe(
                    () => data.schedules[0].sub_lang_1_iso_2,
                    getSafe(
                      () => data.schedules_after_midnight[0].sub_lang_1_iso_2,
                      ""
                    )
                  ),
                  getSafe(
                    () => data.schedules[0].sub_lang_2_iso_2,
                    getSafe(
                      () => data.schedules_after_midnight[0].sub_lang_2_iso_2,
                      ""
                    )
                  )
                )
              }}
            </div>
            <!-- <div class="col-4">
              <div class="movie-img">
                <img :src="URL_BASE + data.header_banner" class="img-fluid" />
              </div>
            </div> -->
            <div class="col-12">
              <div class="title pb-1">{{ movieName }}</div>
              <div>
                {{
                  getCinemaTranslatedName(
                    getSafe(
                      () => data.schedules[0].cinema,
                      getSafe(() => data.schedules_after_midnight[0].cinema, "")
                    )
                  )
                }}
              </div>
              <div class="pt-2">
                <ul class="list-inline showtimes__time-tag w-100">
                  <template
                    v-for="(schedule, indexschedule) in data.schedules"
                    class="d-flex"
                  >
                    <li
                      :key="indexschedule"
                      :class="[schedule.showTime]"
                      class="time-tag list-inline-item"
                      @click="seatLayoutShowBrij(schedule, data)"
                    >
                      <a class="text-white" to>
                        {{
                          moment(schedule.showTime, ["HH.mm"])
                            .locale(getCurrentLang().iso_2 || "en")
                            .format("hh:mm A")
                        }}
                      </a>
                    </li>
                  </template>
                </ul>

                <!--
                <ul class="w-60 mb-2 row showtime-line" v-if="data.schedules_after_midnight.length > 0">
                    <img
                      src="@/assets/img/new-img/svg-img/vertical-line.svg"
                      class="image img-fluid"
                    />
                </ul>
                -->
                <div
                  class="d-flex justify-center justify-content-center align-items-center align-content-center"
                  style="min-width: 275px"
                  v-if="data.schedules_after_midnight.length > 0"
                >
                  <div style="width: 36%"><hr /></div>
                  <span
                    class="d-flex justify-center justify-content-center align-items-center align-content-center px-2 font-weight-light"
                    style="flex-direction: row"
                  >
                    {{ allLanguageData.AfterMidnight }}
                  </span>
                  <div style="width: 36%"><hr /></div>
                </div>

                <ul
                  class="list-inline showtimes__time-tag schedules_after_midnight"
                  v-if="data.schedules_after_midnight.length > 0"
                >
                  <template
                    v-for="(
                      schedule, indexschedule
                    ) in data.schedules_after_midnight"
                    class="d-flex"
                  >
                    <li
                      :key="indexschedule"
                      :class="[schedule.showTime]"
                      class="time-tag list-inline-item"
                      @click="seatLayoutShowBrij(schedule, data)"
                    >
                      <a class="text-white" to>
                        {{
                          moment(schedule.showTime, ["HH.mm"])
                            .locale(getCurrentLang().iso_2 || "en")
                            .format("hh:mm A")
                        }}
                      </a>
                    </li>
                  </template>
                </ul>
              </div>
            </div>
          </div>
          <hr class="showtime-line" />
          <div>
            <div class="no-shows-found"></div>
          </div>
        </div>
      </div>
      <div
        v-if="
          filteredFlattenedSchedule && filteredFlattenedSchedule.length <= 0
        "
      >
        {{ isMovies }}
      </div>
      <b-button
        v-if="
          filteredFlattenedSchedule &&
          loadPageNo < paginationCountdata &&
          filteredFlattenedSchedule.length > 0
        "
        class="btn-load-more"
        @click="onLoadMore"
        >Load More
      </b-button>
      <!--End Mobile View-->
      <!-- <b-button v-b-modal="'ruleOfCountryForShows'"
        >Rules of Entry Popup</b-button
      > -->
      <!-- <b-button v-b-modal="'foodanddrinks'">Food and Drinks Popup</b-button> -->
      <!----------- RULES OF ENTRY MODAL ---------->
      <!-- <button  v-b-modal.bookScreen> click</button> -->
      <div
        v-if="showTerms.RatingImage"
        class="emp_new_modal emp-loyalty-modal showtimes-popup"
      >
        <b-modal
          id="ruleOfCountryForShows"
          ref="ruleOfCountryForShows"
          class="rules-country-popup"
          hide-footer
          hide-header-close
          size="lg"
        >
          <template slot="modal-header">
            <div class="row w-100 align-items-center">
              <div class="pr-0 col-1 mb-3 mb-md-0">
                <div
                  class="d-block bg-emp-red"
                  style="height: 3px; width: 100%"
                ></div>
              </div>
              <div class="col-10">
                <h6 class="hiw-title text-center font-weight-bold mb-0">
                  {{ allLanguageData.PopupTerms.Heading }}
                </h6>
              </div>
              <span class="new-closeBtn" @click="HideTermsPopup">X</span>
            </div>
          </template>
          <div class="emp_new_modal_body px-3 py-3">
            <div class="grid-half">
              <div class="text-center">
                <img
                  :src="checkBaseUrl(showTerms.RatingImage)"
                  class="image img-fluid"
                />
              </div>
              <div>
                <h5 class="mb-0 title">
                  {{ showTerms.Title }}
                </h5>
              </div>
            </div>
            <div
              class="rules-list offset-lg-3 mt-3"
              v-html="showTerms.Description"
            ></div>
            <div class="mb-3 offset-lg-3">
              <span>
                {{ allLanguageData.PopupTerms.AgreeText }}
              </span>
              <span>
                <router-link
                  class="font-weight-bold"
                  target="_blank"
                  to="/ksa-terms-condition"
                >
                  <u>{{ allLanguageData.PopupTerms.TnC }}</u>
                </router-link>
                &nbsp;{{ allLanguageData.PopupTerms.And }}
                <router-link
                  class="font-weight-bold"
                  target="_blank"
                  to="/theatre-rules"
                >
                  <u>{{ allLanguageData.PopupTerms.HouseRules }}</u>
                </router-link>
              </span>
            </div>
            <div class="mx-auto text-center direction-class mt-4">
              <div class="row">
                <div class="col-6 col-md-4 offset-md-2 pr-1">
                  <b-button
                    class="btn btn-yes"
                    variant="default"
                    @click="onClickAgree()"
                    >{{ allLanguageData.PopupTerms.AgreeButton }}
                  </b-button>
                </div>
                <div class="col-6 col-md-4 pl-1">
                  <b-button
                    class="btn btn-no"
                    variant="default"
                    @click="HideTermsPopup()"
                    >{{ allLanguageData.PopupTerms.CancelButton }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </b-modal>
        <b-modal
          id="bookScreen"
          ref="bookScreen"
          class="rules-country-popup"
          hide-footer
          size="md"
          title="Booking Information"
        >
          <div class="emp_new_modal_body py-3 px-3">
            <h5 class="font-weight-bold">Contact the cinema</h5>
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>
<script>
import { makeRequestBrij } from "@/helper/internet.js";
import Multiselect from "vue-multiselect";
import MobileMovieDetails from "@/components/partials/mobilemoviedetails";
import moment from "moment";
import { URL_BASE } from "@/helper/constant.js";
import { LanguageService } from "../../services/storage.service";

export default {
  data() {
    return {
      is_loading: true,
      selectedDate: null,
      ss_id: null,
      md_id: null,
      screen_id: null,
      dateList: [],
      BrijScheduled: [],
      confirmedMovie: {
        status: true,
        message: "Records Fetched",
        Records: { data: [], pagination: {} },
        VersionNameArray: [],
        sessions: [],
        MovieListArray: [{ CinemaList: [] }],
        MovieListArrayNew: [{ CinemaList: [] }],
        FormatArray: [],
        CinemaArray: [],
        LanguageArray: [],
        dateList: [],
        disable_date_list: [],
        isShowScreening: true,
        TypeList: [],
        FilterData: [],
      },
      flattenSchedule: [],
      URL_BASE: URL_BASE + "/",
      showContent: false,
      offerId: null,
      listView: true,
      gridView: false,
      bannerSlider: {
        arrows: false,
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToScroll: 1,
        slidesToShow: 1,
      },
      dateSlider: {
        draggable: true,
        accessibility: false,
        slidesToShow: 7,
        arrows: true,
        dots: false,
        swipeToSlide: true,
        infinite: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 700,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
              adaptiveHeight: true,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
            },
          },
        ],

        // new
      },
      MovieID: [],
      CategoryID: "",
      showAllDateList: [],
      AllTimesArray: [],
      movieDetails: [],
      tempAllShowData: [],
      allCinemas: [],
      AllFormatsArray: [],
      isMovies: "",
      cinemaList: [],
      finalSelectedDate: "",
      filteredCinamaArray: [],
      filteredExpArray: [],
      selectedCinemaValues: [],
      selectedExpValues: [],
      selectedShowTimes: [],
      filteredTimesArray: [],
      hideCinemaFilter: false,
      isLoadmoreActivated: false,
      refreshMovies: true,
      loadPageNo: 1,
      paginationCountdata: 0,
      SchID: "",
      showTerms: {
        Description: "",
        Title: "",
        rated: "",
        RatingImage: "",
      },
      movieBanner: "",
      movieName: "",
      movieDescrip: "",
    };
  },
  destroyed() {
    window.localStorage.setItem("EXPE", "");
  },
  beforeCreate: function () {
    document.body.className = "light-section";
  },
  mounted() {
    this.fetchCinemaList();
    // this.fetchExperienceList();
  },
  beforeMount() {
    console.log(this.BrijBaseUrl, "BrijBaseUrl");
    if (window.localStorage.getItem("EXPE")) {
      let EXP = window.localStorage.getItem("EXPE");

      console.log(EXP, "EXP");

      this.filteredExpArray.push(EXP);
      // this.selectedExpValues.push(EXP);
    }
    // if (this.headerCinemaId) {
    //   this.finalSelectedDate = ''
    //   this.filteredCinamaArray.push(this.headerCinemaId)
    // }
    const { movieId } = this.$route.params;

    if (movieId) {
      this.MovieID = movieId.toString().split(",");

      this.CategoryID = this.$route.params.cat_id;
      this.getAllMovieDetails(this.MovieID);
    } else {
      console.log(this.$route.params, "jitu");
      // this.$router.go(-1);
    }

    if (
      this.$store.getters.getSelectedBrijCinemas &&
      Object.keys(this.$store.getters.getSelectedBrijCinemas).length
    ) {
      this.selectedCinemaValues.push(
        this.$store.getters.getSelectedBrijCinemas
      );
    }
  },

  beforeUpdate() {
    if (this.$refs.dateSlider) {
      this.$refs.dateSlider.destroy();
    }
  },
  updated() {
    this.$nextTick(function () {
      if (this.$refs.dateSlider) {
        this.$refs.dateSlider.create(this.slickOptions);
      }
    });
  },
  components: {
    Multiselect,
    moment,
    MobileMovieDetails,
  },
  watch: {
    headerCinemaId: {
      handler: function (newVal, oldVal) {
        this.refreshMovies = true;
        this.loadPageNo = 1;
        // let obj = this.cinemaList.filter(y => {
        //   return y.CinemaID == this.headerCinemaId;
        // });

        // if (obj.length > 0) {
        //   this.filteredCinamaArray = [];

        // }
        this.selectedCinemaValues = [];

        let obj = this.cinemaList.filter((y) => {
          return y.CinemaID == this.headerCinemaId;
        });
        if (obj.length > 0) {
          this.selectedCinemaValues.push(...obj);
          this.hideCinemaFilter = true;
        } else {
          this.hideCinemaFilter = false;
        }
      },
      deep: true,
    },
  },
  computed: {
    headerCinemaId() {
      return this.$store.state.headerCinemaStore.headerCinemaId;
    },
    filteredFlattenedSchedule() {
      let filtered = JSON.parse(JSON.stringify(this.BrijScheduled));

      let isAllCinemaSelected = this.selectedCinemaValues.some(
        (c) => c.cinema_id === ""
      );
      let isAllFormatSelected = this.selectedExpValues.some(
        (c) => c.mf_id === ""
      );
      let isAllSessionsSelected = this.selectedShowTimes.length === 4; // some(c => c.label === 'All')

      if (isAllCinemaSelected && isAllFormatSelected && isAllSessionsSelected) {
        return filtered;
      }

      if (isAllCinemaSelected) this.selectedCinemaValues = [];
      if (isAllFormatSelected) this.selectedExpValues = [];
      if (isAllSessionsSelected) this.selectedShowTimes = [];

      let cinema_ids = this.selectedCinemaValues
        .map((c) => c.cinema_id)
        .filter((x) => !!x);
      let mf_ids = this.selectedExpValues
        .map((c) => c.mf_id)
        .filter((x) => !!x);
      let sessions = this.selectedShowTimes
        .map((c) => c.label)
        .filter((x) => !!x);

      filtered = filtered
        .filter((x) => {
          if (isAllCinemaSelected || cinema_ids.length === 0) return true;

          return cinema_ids.includes(x.cinema_id);
        })
        .filter((x) => {
          if (
            isAllFormatSelected ||
            mf_ids.length === 0 ||
            x.schedules.length === 0 ||
            x.mf_ids.length === 0
          ) {
            return true;
          }

          return x.mf_ids.some((x) => mf_ids.includes(x));
        })
        .map((x) => {
          if (sessions.length > 0) {
            x.schedules = x.schedules.filter((s) => {
              if (
                sessions.includes("Morning") &&
                s.show_timing_label == "Night" &&
                s.isPrevDayAmShow
              ) {
                return true;
              }

              if (s.show_timing_label == "Night") {
                return (
                  sessions.includes(s.show_timing_label) && !s.isPrevDayAmShow
                );
              }

              return sessions.includes(s.show_timing_label);
            });

            x.schedules_after_midnight = x.schedules_after_midnight.filter(
              (s) => sessions.includes(s.show_timing_label)
            );
          }

          return x;
        })
        // .sort((a, b) => {
        //   let comparison = a.cinema_id - b.cinema_id
        //
        //   if (comparison === 0) { comparison = a.movie_ids[0] - b.movie_ids[0] }
        //   if (comparison === 0) { comparison = a.md_id - b.md_id }
        //
        //   return comparison
        // })
        .map((x) => {
          x.schedules = x.schedules.sort((a, b) => {
            if (
              String(a.showTime).startsWith("0") &&
              String(b.showTime).startsWith("0") &&
              String(a.show_timing_label).startsWith("Night") &&
              String(b.show_timing_label).startsWith("Night")
            ) {
              return a.date_unix - b.date_unix;
            } else if (
              (String(a.showTime).startsWith("0") ||
                String(b.showTime).startsWith("0")) &&
              (String(a.show_timing_label).startsWith("Night") ||
                String(b.show_timing_label).startsWith("Night"))
            ) {
              return b.date_unix - a.date_unix;
            } else {
              return a.date_unix - b.date_unix;
            }
          });
          x.ss_actual_start_date = x.schedules[0]
            ? x.schedules[0].ss_actual_start_date
            : x.schedules_after_midnight[0]
            ? x.schedules_after_midnight[0].ss_actual_start_date
            : "";
          return x;
        });

      return filtered;
    },
  },
  methods: {
    getCinemaTranslatedName(cinema) {
      if (!cinema) return "";

      let name = "";
      if (this.langName === "ar" && cinema.alternateLangName) {
        name = cinema.alternateLangName;
      } else {
        name =
          this.getLangSpecificAttribute(
            cinema.translation_data || [],
            this.getCurrentLang().brij_lang_id,
            "cinema_name",
            "langaugeId"
          ) || cinema.cinema_name;
      }
      return name;
    },
    getOptionsWithArabicNames(options) {
      return options.map((option) => ({
        ...option,
        mf_name: this.getArabicmfName(option.mf_name),
      }));
    },
    getArabicmfName(name) {
      return name
        .replace("All", "الجميع")
        .replace("MINIS", "مينيز")
        .replace("SPHERA", "سفيرا")
        .replace("IMAX", "أيماكس")
        .replace("SCREEN X", "سكرين أكس")
        .replace("4DX", "فور دي اكس")
        .replace("EMPIRE PREMIERE", "امباير بريمير")
        .replace("2D ATMOS", "أتموس ثنائي الأبعاد")
        .replace("4D X", "فور دي اكس");
    },
    getArabicScreenName(name) {
      name = name.toUpperCase();

      return name
        .replace("MINIS", "مينيز")
        .replace("MINIS 1", "مينيز1")
        .replace("MINIS 2", "2مينيز")
        .replace("MINIS 3", "3مينيز")
        .replace("MINIS 4", "4مينيز")
        .replace("MINIS 5", "5مينيز")
        .replace("MINIS 6", "6مينيز")
        .replace("MINIS 7", "7مينيز")
        .replace("MINIS 8", "8مينيز")
        .replace("MINIS 9", "9مينيز")
        .replace("MINIS 10", "10مينيز")
        .replace("SPHERA", "سفيرا")
        .replace("IMAX", "أيماكس")
        .replace("SCREEN X", "سكرين أكس")
        .replace("4DX", "فور دي اكس")
        .replace("4D X", "فور دي اكس")
        .replace("EMPIRE PREMIERE", "امباير بريمير")
        .replace("SCREEN 1", "الشاشة ١")
        .replace("SCREEN 2", "الشاشة ٢")
        .replace("SCREEN 3", "الشاشة ٣")
        .replace("SCREEN 4", "الشاشة ٤")
        .replace("SCREEN 5", "الشاشة ٥")
        .replace("SCREEN 6", "الشاشة ٦")
        .replace("SCREEN 7", "الشاشة ٧")
        .replace("SCREEN 8", "الشاشة ٨")
        .replace("SCREEN 9", "الشاشة ٩")
        .replace("SCREEN 10", "الشاشة ١٠")
        .replace("SCREEN 11", "الشاشة ١١")
        .replace("SCREEN 12", "الشاشة ١٢")
        .replace("SCREEN 13", "الشاشة ١٣")
        .replace("SCREEN 14", "الشاشة ١٤")
        .replace("SCREEN 15", "الشاشة ١٥")
        .replace("SCREEN 16", "الشاشة ١٦")
        .replace("SCREEN 17", "الشاشة ١٧")
        .replace("SCREEN 18", "الشاشة ١٨")
        .replace("SCREEN 19", "الشاشة ١٩")
        .replace("SCREEN 20", "الشاشة ٢٠")
        .replace("SCREEN 21", "الشاشة ٢١")
        .replace("SCREEN 22", "الشاشة ٢٢")
        .replace("SCREEN 23", "الشاشة ٢٣")
        .replace("SCREEN 24", "الشاشة ٢٤")
        .replace("SCREEN 25", "الشاشة ٢٥")
        .replace("SCREEN 01", "الشاشة ١")
        .replace("SCREEN 02", "الشاشة ٢")
        .replace("SCREEN 03", "الشاشة ٣")
        .replace("SCREEN 04", "الشاشة ٤")
        .replace("SCREEN 05", "الشاشة ٥")
        .replace("SCREEN 06", "الشاشة ٦")
        .replace("SCREEN 07", "الشاشة ٧")
        .replace("SCREEN 08", "الشاشة ٨")
        .replace("SCREEN 09", "الشاشة ٩");
    },
    getArabicTimeLabel(label) {
      switch (label) {
        case "Morning":
          return "صباحًا";
        case "Afternoon":
          return "بعد الظهر";
        case "Night":
          return "ليلا";
        case "Evening":
          return "مساء";
        default:
          return label;
      }
    },
    moment,
    onLoadMore() {
      this.refreshMovies = false;
      this.loadPageNo = this.loadPageNo + 1;
      this.getAllMovieDetails();
    },
    seatLayoutShowBrij(schedule, data) {
      console.log({ schedule, data });
      console.log(this.movieDetails);
      if (this.CountryID == 102 || this.CountryID == "102") {
        this.$refs["bookScreen"].show();
        return false;
      }
      this.ss_id = schedule.ss_id;
      this.md_id = schedule.md_id;
      this.screen_id = schedule.screen_id;
      let rating_id =
        this.movieDetails.length > 0 && this.movieDetails[0].rating_id
          ? this.movieDetails[0].rating_id
          : null;
      if (rating_id) {
        makeRequestBrij(
          `/rating_popup/?rating_id=${rating_id}`,
          "GET",
          null,
          null
        )
          .then((response) => {
            const { res } = response;
            if (
              res &&
              res.data &&
              res.data.Records &&
              res.data.Records.length > 0
            ) {
              const popData = res.data.Records.filter(
                (p) => p.pp_lang_id == this.getCurrentLang().brij_lang_id
              ).length
                ? res.data.Records.filter(
                    (p) => p.pp_lang_id == this.getCurrentLang().brij_lang_id
                  )[0]
                : res.data.Records[0];
              console.log(popData);
              this.showTerms.RatingImage = popData.pp_banner;
              this.showTerms.Description = popData.pp_description;
              this.showTerms.rated = popData.rating_name;
              this.showTerms.Title = popData.pp_title;

              this.ShowTermsPopup();
            } else {
              this.onClickAgree();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    seatLayoutShow(data, dataShowTerms) {
      if (this.CountryID == 102 || this.CountryID == "102") {
        this.$refs["bookScreen"].show();
        return false;
      }
      this.SchID = data.SchID;
      if (
        dataShowTerms &&
        dataShowTerms.ShowTerms &&
        dataShowTerms.ShowTerms.length > 0
      ) {
        this.showTerms.Title = dataShowTerms.ShowTerms[0].Title;
        this.showTerms.Description = dataShowTerms.ShowTerms[0].Description;
        this.showTerms.rated = dataShowTerms.ShowTerms[0].rated;
        this.showTerms.RatingImage = dataShowTerms.ShowTerms[0].RatingImage;
        this.ShowTermsPopup();
      } else {
        this.$router.push({
          path: "/seatLayout/" + data.SchID,
        });
      }
    },
    onClickAgree() {
      this.$router.push({
        path: `/seatLayout/${this.ss_id}/${this.md_id}/${this.screen_id}`,
      });
    },
    ShowTermsPopup() {
      this.$nextTick(() => {
        this.$refs["ruleOfCountryForShows"].show();
      });
    },
    HideTermsPopup() {
      this.$refs["ruleOfCountryForShows"].hide();
    },
    getAllMovieDetailsBrij() {
      let movie_id = this.MovieID[0];
      makeRequestBrij(`/api/cinema/movie-detail/${movie_id}/1/`, "GET", null, {
        user_lang_id: 1,
      }).then((response) => {
        let language = LanguageService.getLanguage();

        const { error, res } = response;
        if (res.data.status) {
          this.movieDetails = res.data.Records;
          this.$forceUpdate();

          // this.movieBanner = this.checkBaseUrl(this.movieDetails[0].artwork)
          // this.movieName = this.getLanguageDetail(this.movieDetails[0].altMovieContent, 'iso_2', 'mc_title') || this.movieDetails[0].mc_title
          // this.movieDescrip = this.getLanguageDetail(this.movieDetails[0].altMovieContent, 'iso_2', 'mc_plot') || this.movieDetails[0].mc_plot
          // console.log(this.movieName, this.movieDescrip, 'this.movieBanner')

          if (this.movieDetails.length) {
            // this.movieBanner = this.checkBaseUrl(
            //   this.getLangSpecificAttribute(
            //     this.movieDetails[0].altMovieContent,
            //     language.brij_lang_id,
            //     'artwork'
            //   ) ||
            //   this.movieDetails[0].artwork
            // )
            this.movieBanner = this.checkBaseUrl(
              this.getLangSpecificAttribute(
                (this.movieDetails[0].movie_poster || []).filter(
                  (p) =>
                    p.image_setting_width == 1520 &&
                    p.image_setting_height == 500
                ),
                this.getCurrentLang().brij_lang_id,
                "mp_poster_url"
              ) ||
                this.getSafe(
                  () =>
                    (this.movieDetails[0].movie_poster || []).filter(
                      (p) =>
                        p.image_setting_width == 1520 &&
                        p.image_setting_height == 500
                    )[0].mp_poster_url
                )
            );

            this.movieName =
              this.getLangSpecificAttribute(
                this.movieDetails[0].altMovieContent,
                this.getCurrentLang().brij_lang_id,
                "mc_title"
              ) ||
              this.movieDetails[0].movie_title ||
              this.movieDetails[0].original_title_of_movie;

            this.movieDescrip =
              this.getLangSpecificAttribute(
                this.movieDetails[0].altMovieContent,
                this.getCurrentLang().brij_lang_id,
                "mc_plot"
              ) || this.movieDetails[0].mc_plot;
          }
        }
      });
    },
    getConfirmedList(movie_id, fromDate = null) {
      if (fromDate) this.showLoading();
      let payload = {};

      if (fromDate && moment(fromDate).isValid()) {
        payload.fromDate = moment(fromDate).format("YYYY-MM-DD");
      }
      if (
        this.$store.getters.getSelectedBrijCinemas &&
        Object.keys(this.$store.getters.getSelectedBrijCinemas).length
      ) {
        payload.cinema_id =
          this.$store.getters.getSelectedBrijCinemas.cinema_id;
      }

      // if comming from experience page then get movies for that experience by mf_id
      let format_with_id = this.getSafe(
        () => this.$route.query.format_with_id || "",
        ""
      )
        .split(",")
        .map((f) => {
          let [id, fm] = f.split("-");
          let f_name = String(fm).toLowerCase();
          let f_name_fxp_name_mapping = String(fm).toLowerCase();

          if (f_name.includes("atmos") || f_name.includes("dolby")) {
            f_name_fxp_name_mapping = "atmos";
          }
          if (f_name.includes("sphera")) f_name_fxp_name_mapping = "sphera";
          if (f_name.includes("flexound")) f_name_fxp_name_mapping = "flexound";
          if (f_name.includes("premiere")) f_name_fxp_name_mapping = "premiere";

          if (f_name == "screen x") f_name_fxp_name_mapping = "screenx";
          if (f_name == "4 dx" || f_name == "4d x") {
            f_name_fxp_name_mapping = "4dx";
          }
          return [id, f_name_fxp_name_mapping];
        });
      let s =
        String(this.$route.params.expName).includes("atmos") ||
        String(this.$route.params.expName).includes("dolby")
          ? "atmos"
          : String(this.$route.params.expName).includes("sphera")
          ? "sphera"
          : String(this.$route.params.expName).includes("flexound")
          ? "flexound"
          : String(this.$route.params.expName).includes("premiere")
          ? "premiere"
          : String(this.$route.params.expName);

      let fm_id_to_get = null;

      format_with_id.forEach((f) => {
        if (f[1] == s) {
          fm_id_to_get = f[0];
        }
      });
      if (
        fm_id_to_get &&
        this.$route.params.expName &&
        String(this.$route.params.expName) &&
        String(this.$route.params.expName) !== "all"
      ) {
        payload.mf_id = fm_id_to_get;
      }
      this.is_loading = true;
      makeRequestBrij(
        `/api/cinema/admin/movie-confirmed-list/${movie_id}`,
        "GET",
        null,
        payload
      )
        .then((response) => {
          const { error, res } = response;

          if (res.data.status) {
            this.confirmedMovie = res.data;

            if (!this.selectedDate) {
              this.dateList = response.res.data.dateList;

              if(response.res.data.dateList && response.res.data.dateList.length) {
                return this.setSelectedDate(response.res.data.dateList[0].ss_actual_start_date, response.res.data.dateList[0])
              }
            }

            let confirmedMovie = res.data;
            let flattenSchedule = [];
            // let flattenScheduleEntries = null
            let flattenSchedulegroupByToMap = null;

            confirmedMovie.MovieListArrayNew.forEach((m) => {
              m.CinemaList.forEach((c) => {
                let { format_list = [], ...cinema } = c;

                format_list.forEach((f) => {
                  let { screens = [], ...movieversion } = f;

                  screens.forEach((scr) => {
                    let {
                      schedule_list = [],
                      midnight_schedule_array = [],
                      ...screen
                    } = scr;

                    schedule_list.forEach((sh) => {
                      flattenSchedule.push({
                        ...cinema,
                        ...movieversion,
                        ...screen,
                        cinema,
                        movieversion,
                        screen,
                        ...sh,
                        isAfterMidnight: false,
                      });
                    });

                    midnight_schedule_array.forEach((sh) => {
                      flattenSchedule.push({
                        ...cinema,
                        ...movieversion,
                        ...screen,
                        cinema,
                        movieversion,
                        screen,
                        ...sh,
                        isAfterMidnight: true,
                      });
                    });
                  });
                });
              });
            });

            flattenSchedulegroupByToMap = new Map(
              this.groupByToMap(flattenSchedule, (x) =>
                JSON.stringify({
                  cinema_id: x.cinema_id,
                  md_id: x.md_id,
                })
              )
            );
            // flattenScheduleEntries = new Map(this.groupByToMap(flattenSchedule, x => (JSON.stringify({cinema: x.cinema_id, md_id: x.md_id})))).entries()
            this.flattenSchedule = flattenSchedulegroupByToMap;

            let groupedShowsByMd = [];
            for (const [key, value] of flattenSchedulegroupByToMap) {
              let cinema = JSON.parse(String(key));
              let shows = [...value];

              // shows.forEach(ss => {
              //   ss.isPrevDayAmShow = moment(ss.showTime, ['HH.mm'])
              //     .locale('en')
              //     .format('hh:mm A')
              //     .toLowerCase()
              //     .includes('am')
              // })

              groupedShowsByMd.push({
                ...cinema,
                schedules: shows.filter((x) => !x.isAfterMidnight),
                schedules_after_midnight: shows.filter(
                  (x) => x.isAfterMidnight
                ),
              });
            }

            groupedShowsByMd.map((x) => {
              x.mf_names = [
                ...new Set([
                  ...x.schedules.map((m) => m.mf_name),
                  ...x.schedules_after_midnight.map((m) => m.mf_name),
                ]),
              ]
                .filter((x) => !!x)
                .join(",");
              x.mf_ids = [
                ...new Set([
                  ...x.schedules.map((m) => m.mf_id),
                  ...x.schedules_after_midnight.map((m) => m.mf_id),
                ]),
              ].filter((x) => !!x);
              x.movie_ids = [
                ...new Set([
                  ...x.schedules.map((m) => m.movie_id),
                  ...x.schedules_after_midnight.map((m) => m.movie_id),
                ]),
              ].filter((x) => !!x);
              return x;
            });

            // console.log({
            //   flattenSchedule,
            //   flattenSchedulegroupByToMap,
            //   flattenScheduleEntries,
            //   groupedShowsByMd
            // })
            this.BrijScheduled = groupedShowsByMd;
          }

          this.$forceUpdate();
        })
        .catch(() => {
          this.confirmedMovie = {};
          if (!this.selectedDate) {
            this.dateList = [];
          }
        })
        .finally(() => {
          this.$nextTick(() => {
            console.log(this.$refs.hey);
            // ...other synchronous work here that causes other DOM changes
            this.is_loading = false;
          });
          if (fromDate) this.hideLoading();
        })
        .then(() => {
          /*
          let payload = {}

          if (fromDate && moment(fromDate).isValid()) {
            payload.fromDate = moment(fromDate)
              .add("1", "d")
              .format("YYYY-MM-DD");
          } else {
            payload.fromDate = moment()
              .add("1", "d")
              .format("YYYY-MM-DD");
          }

          if (
            this.$store.getters.getSelectedBrijCinemas &&
            Object.keys(this.$store.getters.getSelectedBrijCinemas).length
          ) {
            payload.cinema_id = this.$store.getters.getSelectedBrijCinemas.cinema_id;
          }

          // if comming from experience page then get movies for that experience by mf_id
          let format_with_id = this.getSafe(
            () => this.$route.query.format_with_id || "",
            ""
          )
            .split(",")
            .map((f) => {
              let [id, fm] = f.split("-");
              let f_name = String(fm).toLowerCase();
              let f_name_fxp_name_mapping = String(fm).toLowerCase();

              if (f_name.includes("atmos") || f_name.includes("dolby")) {
                f_name_fxp_name_mapping = "atmos";
              }
              if (f_name.includes("sphera")) f_name_fxp_name_mapping = "sphera";
              if (f_name.includes("flexound"))
                f_name_fxp_name_mapping = "flexound";
              if (f_name.includes("premiere"))
                f_name_fxp_name_mapping = "premiere";

              if (f_name == "screen x") f_name_fxp_name_mapping = "screenx";
              if (f_name == "4 dx" || f_name == "4d x") {
                f_name_fxp_name_mapping = "4dx";
              }
              return [id, f_name_fxp_name_mapping];
            });
          let s =
            String(this.$route.params.expName).includes("atmos") ||
            String(this.$route.params.expName).includes("dolby")
              ? "atmos"
              : String(this.$route.params.expName).includes("sphera")
              ? "sphera"
              : String(this.$route.params.expName).includes("flexound")
              ? "flexound"
              : String(this.$route.params.expName).includes("premiere")
              ? "premiere"
              : String(this.$route.params.expName);

          let fm_id_to_get = null;

          format_with_id.forEach((f) => {
            if (f[1] == s) {
              fm_id_to_get = f[0];
            }
          });
          if (
            fm_id_to_get &&
            this.$route.params.expName &&
            String(this.$route.params.expName) &&
            String(this.$route.params.expName) !== "all"
          ) {
            payload.mf_id = fm_id_to_get;
          }
          makeRequestBrij(
            `/api/cinema/admin/movie-confirmed-list/${movie_id}`,
            "GET",
            null,
            payload
          )
            .then((response) => {
              const { error, res } = response;

              if (res.data.status) {
                let confirmedMovie = res.data;
                let flattenSchedule = [];
                let flattenSchedulegroupByToMap = null;

                confirmedMovie.MovieListArrayNew.forEach((m) => {
                  m.CinemaList.forEach((c) => {
                    let { format_list = [], ...cinema } = c;

                    format_list.forEach((f) => {
                      let { screens = [], ...movieversion } = f;

                      screens.forEach((scr) => {
                        let { schedule_list = [], ...screen } = scr;

                        schedule_list.forEach((sh) => {
                          flattenSchedule.push({
                            ...cinema,
                            ...movieversion,
                            ...screen,
                            cinema,
                            movieversion,
                            screen,
                            ...sh,
                          });
                        });
                      });
                    });
                  });
                });

                flattenSchedulegroupByToMap = new Map(
                  this.groupByToMap(flattenSchedule, (x) =>
                    JSON.stringify({
                      cinema_id: x.cinema_id,
                      md_id: x.md_id,
                    })
                  )
                );

                flattenSchedule = flattenSchedulegroupByToMap;

                let groupedShowsByMd = [];
                for (const [key, value] of flattenSchedulegroupByToMap) {
                  let cinema = JSON.parse(String(key));
                  let shows = [...value];
                  shows.forEach((ss) => {
                    let time = moment(ss.showTime, ["HH.mm"])
                      .locale("en")
                      .format("hh:mm A")
                      .toLowerCase();

                    ss.isNextDayAmShow =
                      time.includes("am") &&
                      (time.startsWith("12") ||
                        time.startsWith("01") ||
                        time.startsWith("02") ||
                        time.startsWith("03") ||
                        time.startsWith("04") ||
                        time.startsWith("05"));
                  });
                  // console.log({cinema, shows})
                  groupedShowsByMd.push({
                    ...cinema,
                    schedules: shows,
                  });
                }

                groupedShowsByMd.map((x) => {
                  x.mf_names = [...new Set(x.schedules.map((m) => m.mf_name))]
                    .filter((x) => !!x)
                    .join(",");
                  x.mf_ids = [
                    ...new Set(x.schedules.map((m) => m.mf_id)),
                  ].filter((x) => !!x);
                  x.movie_ids = [
                    ...new Set(x.schedules.map((m) => m.movie_id)),
                  ].filter((x) => !!x);
                  return x;
                });

                // console.log({
                //   flattenSchedule,
                //   flattenSchedulegroupByToMap,
                //   flattenScheduleEntries,
                //   groupedShowsByMd
                // })
                let BrijScheduled = groupedShowsByMd;

                this.BrijScheduled.forEach((todays) => {
                  BrijScheduled.forEach((tomorrows) => {
                    if (
                      todays.cinema_id === tomorrows.cinema_id &&
                      todays.md_id === tomorrows.md_id
                    ) {
                      todays.schedules_after_midnight = tomorrows.schedules.filter(
                        (x) => x.isNextDayAmShow
                      );
                    }
                  });
                });
              }

              this.$forceUpdate();
            })
            .catch(() => {
              console.log(`failed to get next date`)
            })
          */
        })
        .finally(() => {
          console.log(this.selectedDate, "this.selectedDate");
          // if (
          //   !this.selectedDate &&
          //   this.dateList[0] &&
          //   this.dateList[0].ss_actual_start_date &&
          //   this.filteredFlattenedSchedule[0] &&
          //   this.filteredFlattenedSchedule[0].ss_actual_start_date !=
          //     this.dateList[0].ss_actual_start_date
          // ) {
          //   this.selectedDate =
          //     this.filteredFlattenedSchedule[0].ss_actual_start_date;
          // }
        });
    },
    getAllMovieDetails: function (movieIdValue) {
      this.getAllMovieDetailsBrij();
      this.getConfirmedList(this.MovieID[0], this.selectedDate);
      this.isMovies = "";
      let payload = {
        MovieID: this.MovieID,
        CategoryID: this.CategoryID,
        CinemaID: this.filteredCinamaArray,
        Format: this.filteredExpArray,
        pageNo: this.loadPageNo,
        ShowTimes: this.filteredTimesArray,
      };

      if (this.finalSelectedDate) {
        payload["ShowDate"] = this.finalSelectedDate
          ? this.finalSelectedDate
          : "";
      }

      console.log(payload, "payload");

      this.tempAllShowData = [];
      this.allCinemas = [];
      if (this.refreshMovies == true) {
        this.allCinemas = [];
      }

      if (this.finalSelectedDate) {
      } else {
        this.showAllDateList = [];
      }
      // this.showLoading()
      // makeRequest('/GetShowtimesByMovie/', 'POST', null, payload)
      //   .then((response) => {
      //     const { error, res } = response // console.log("Show details", res);
      //     if (res.data.Status && res.data.AllShowdates.length > 0) {
      //       this.hideLoading()
      //       if (
      //         res.data.hasOwnProperty('MovieData') &&
      //         res.data.MovieData.length > 0
      //       ) {
      //         this.tempAllShowData = res.data.MovieData
      //         if (!this.finalSelectedDate) {
      //           if (this.tempAllShowData.length > 0) {
      //             // this.movieDetails = this.tempAllShowData
      //             // this.movieBanner = this.movieDetails[0].banner_image
      //             // this.movieName = this.movieDetails[0].movie_name
      //             // this.movieDescrip = this.movieDetails[0].synopsis
      //           }
      //         } else {
      //         }
      //
      //         // if (
      //         //   this.tempAllShowData.length > 0 &&
      //         //   this.tempAllShowData[0].Showdates.length > 0
      //         // ) {
      //         //   this.paginationCountdata = this.tempAllShowData[0].Showdates[0].TotalpageData[0].Totalpages;
      //         // }
      //       }
      //
      //       if (this.finalSelectedDate) {
      //         this.scheduleDate(this.finalSelectedDate)
      //       } else {
      //         if (
      //           res.data.hasOwnProperty('AllShowdates') &&
      //           res.data.AllShowdates.length > 0
      //         ) {
      //           this.showAllDateList = res.data.AllShowdates
      //
      //           this.scheduleDate(this.showAllDateList[0].showdate)
      //           if (
      //             res.data.hasOwnProperty('AllTimes') &&
      //             res.data.AllTimes.length > 0
      //           ) {
      //             this.AllTimesArray = res.data.AllTimes
      //             let objMviAll = {
      //               title: 'ALL TIMES',
      //               ID: 'ALL',
      //             }
      //
      //             this.AllTimesArray.unshift(objMviAll)
      //           }
      //         } else {
      //           this.isMovies = 'NO SHOWS FOUND'
      //         }
      //         if (
      //           res.data.hasOwnProperty('AllFormats') &&
      //           res.data.AllFormats.length > 0
      //         ) {
      //           this.AllFormatsArray = res.data.AllFormats
      //           let objMviAll = {
      //             Metascore: 'ALL FORMATS',
      //             MetascoreID: 'ALL',
      //           }
      //
      //           this.AllFormatsArray.unshift(objMviAll)
      //         }
      //
      //         if (res.data.hasOwnProperty('TotalpageData')) {
      //           this.paginationCountdata = res.data.TotalpageData.Totalpages
      //         }
      //         // if (res.data.hasOwnProperty("countdata") && res.data.countdata) {
      //         //   this.paginationCountdata = res.data.countdata;
      //         // }
      //         // if (
      //         //   res.data.hasOwnProperty("TotalpageData") &&
      //         //   res.data.TotalpageData.length > 0
      //         // ) {
      //         //   alert();
      //         //   this.paginationCountdata = res.data.TotalpageData[0].Totalpages;
      //         // }
      //       }
      //     } else {
      //       this.isMovies = 'NO SHOWS FOUND'
      //     }
      //
      //     this.hideLoading()
      //   })
      //   .catch((error) => {
      //     this.hideLoading()
      //     console.log('Error', error)
      //   })
    },
    setSelectedDate(fromDate = new Date(), dateInfo = {}) {
      console.log({ fromDate, dateInfo });

      if (fromDate && moment(fromDate).isValid()) {
        let date = moment(fromDate).format("YYYY-MM-DD");
        this.selectedDate = date;
        this.getConfirmedList(this.MovieID[0], date);
      }
      this.$forceUpdate();
    },
    scheduleDateMovie(showDate, id) {
      this.finalSelectedDate = showDate;
      if (id == "1") {
        this.loadPageNo = 1;
        this.refreshMovies = true;
      }
      this.getAllMovieDetails();
    },

    scheduleDate: function (showDate) {
      // this.allCinemas = [];
      if (this.refreshMovies == true) {
        this.allCinemas = [];
      }
      this.showLoading();
      try {
        this.finalSelectedDate = showDate;
        if (
          this.tempAllShowData.length > 0 &&
          this.tempAllShowData[0].Showdates.length > 0
        ) {
          let selectedDateShowTimes = this.tempAllShowData[0].Showdates.filter(
            (x) => {
              return x.showdate == showDate;
            }
          );

          if (selectedDateShowTimes.length > 0) {
            for (let q = 0; q < selectedDateShowTimes.length; q++) {
              this.allCinemas.push(...selectedDateShowTimes[q].times);
            }
          }
        }
        console.log(this.allCinemas, "uu");
        // this.hideLoading();
        setTimeout(() => {
          this.hideLoading();
        }, 500);

        // this.hideLoading();
      } catch (error) {
        console.log("error", error);
      }
      // if (showDate) {
      //   this.showLoading();
      // }
      // this.showLoading();
    },
    fetchCinemaList: function () {
      // makeRequest('/GetCinemas', 'POST', null, null)
      //   .then((result) => {
      //     const { error, res } = result
      //     const { data } = res.data
      //     if (res.data) {
      //       this.cinemaList = res.data.Categories
      //
      //       let objcinemaAll = {
      //         CinemaName: 'ALL CINEMAS',
      //         CinemaID: 'ALL',
      //       }
      //
      //       this.cinemaList.unshift(objcinemaAll)
      //
      //       let obj = this.cinemaList.filter((y) => {
      //         return y.CinemaID == this.headerCinemaId
      //       })
      //       if (obj.length > 0) {
      //         this.selectedCinemaValues.push(...obj)
      //         this.hideCinemaFilter = true
      //       }
      //     }
      //   })
      //   .catch((error) => {
      //     console.log('Error on vue front', error)
      //   })
    },
    // fetchExperienceList: function() {
    //   makeRequest("/GetExperience", "POST", null, null)
    //     .then(result => {
    //       const { error, res } = result;
    //       const { data } = res.data;
    //       if (res.data) {
    //         this.AllFormatsArray = res.data.Categories;
    //       }
    //     })
    //     .catch(error => {
    //       console.log("Error on vue front", error);
    //     });
    // },

    showView: function (data) {
      if (data == "grid") {
        (this.gridView = true), (this.listView = false);
      } else {
        (this.gridView = false), (this.listView = true);
      }
    },
    getOfferId: function (index) {
      this.offerId = index;
      this.checkOfferId(index);
      // console.log(index);
    },
    checkOfferId: function (index) {
      console.log(index);
      if (index == this.offerId) {
        console.log("ruchi");
        this.showContent = true;
        return true;
      }
    },
  },
};
</script>
<style>
#bookScreen .close {
  margin-top: -7px;
  margin-right: -10px;
}

#bookScreen .modal-body {
  background: white !important;
  color: black;
}

#bookScreen .modal-title {
  color: black !important;
  margin: initial !important;
}

#bookScreen .emp_new_modal_body {
  color: black !important;
}
.no-shows-found {
  background: #e5e6e7;
  padding: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/cinemashowtimes.vue